import { reportPagelog as reportPagelogRequest } from '@/api/app';
/**
 * @description:
 * 记录进入页面的渠道
 * channel:0/普通进入  1/IM 进入
 * @param {*} url
 * @param {*} uuid
 * @param {*} channel
 * @return {*}
 */
export async function reportPagelog(url, uuid, channel) {
  return await reportPagelogRequest({
    page: 'web' + url,
    uuid,
    channel
  });
}
